﻿import { GDFPalletCode, GradientPalette } from '@fe/weather';
import React from 'react';

function randomId(): string {
    return Math.round(Math.random() * 1e18)
        .toString(36)
        .substring(0, 10);
}

function GradientBarVertical({ data }: { data: GradientPalette }) {
    const { name, suffix, units, stops } = data;
    const maxValue = data.maxDisplayValue ?? data.maxValue;
    const minValue = data.minDisplayValue ?? data.minValue;
    const svgWidth = 80;
    const svgHeight = 300;
    const gradientId = React.useMemo(() => randomId(), []);
    const botPadding = 15;
    const topPadding = stops[stops.length - 1].value === maxValue ? 5 : 0;
    const leftPadding = 0;
    const rectWidth = 15;

    return (
        <div className="legend-entry">
            <div style={{ fontSize: 12 }}>
                {name}
                {import.meta.env.DEV && (
                    <span>
                        {' '}
                        (0x{data.id.toString(16)} {GDFPalletCode[data.id]})
                    </span>
                )}
            </div>
            {units && <span style={{ fontWeight: '500', fontSize: 10, marginLeft: leftPadding + 5 }}>{units}</span>}
            <svg width={svgWidth} height={svgHeight + botPadding + topPadding} style={{ display: 'block' }}>
                <defs>
                    <linearGradient id={gradientId} x1="0%" y1="100%" x2="0%" y2="0%">
                        {stops.map((stop, index) => (
                            <stop
                                key={index}
                                offset={`${((stop.value - minValue) / (maxValue - minValue)) * 100}%`}
                                stopColor={stop.color}
                            />
                        ))}
                    </linearGradient>
                </defs>
                <rect x={leftPadding} y={topPadding} width={rectWidth} height={svgHeight} fill={`url(#${gradientId})`} />
                {stops
                    .filter((x) => !x.hideLabel)
                    .map((stop, index) => (
                        <text
                            key={index}
                            x={leftPadding + rectWidth + 5}
                            y={`${((maxValue - stop.value) / (maxValue - minValue)) * svgHeight + topPadding}`}
                            fontSize="10"
                            textAnchor="start"
                            alignmentBaseline="middle"
                            fill={'var(--text-color)'}>
                            {stop.value}
                            {suffix}
                        </text>
                    ))}
            </svg>
        </div>
    );
}

export default GradientBarVertical;
